function lfBannerInit() {
  var banner = window.lfCollectionBanner;
  if (!banner) return;

  function injectBanner() {
    var slot = document.getElementById("lf-collection-banner-slot");
    if (!slot || slot.dataset.populated) return;
    slot.dataset.populated = "true";

    var imgEl = document.createElement("img");
    imgEl.alt = banner.title || "";
    imgEl.className = "lf-collection-banner__image";

    var mq = window.matchMedia("(max-width: 768px)");
    function updateSrc(e) {
      imgEl.src = (e.matches && banner.mobile_image) ? banner.mobile_image : banner.image;
    }
    updateSrc(mq);
    mq.addEventListener("change", updateSrc);

    var a = document.createElement("a");
    a.href = banner.url || "#";
    a.className = "lf-collection-banner__link";
    if (banner.image) a.appendChild(imgEl);
    a.addEventListener("click", function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
    slot.innerHTML = "";
    slot.appendChild(a);
    slot.style.display = "";
  }

  // Try immediately in case slot is already in the DOM
  injectBanner();

  // Watch for Boost Commerce async rendering inserting the slot
  var observer = new MutationObserver(function () {
    injectBanner();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", lfBannerInit);
} else {
  lfBannerInit();
}
